import moment from 'moment/min/moment-with-locales'

import { type DateObject } from '@/types'
import { getLocale, trans, FROM, TO, UNTIL } from '@helpers/translator'

export const formatDate = (
  startDate: string | DateObject | undefined,
  endDate?: string | DateObject | undefined,
  fullMonth = false,
) => {
  moment.locale(getLocale())

  const monthPattern = fullMonth ? 'MMMM' : 'MMM'

  const formatDate = (
    date: string | DateObject | undefined,
    dateFormat = `DD ${monthPattern} YYYY`,
  ) => {
    if (!date) return null
    const dateString = typeof date === 'string' ? date : date.date
    return moment(dateString).format(dateFormat)
  }

  if (startDate && endDate && formatDate(startDate) !== formatDate(endDate)) {
    const startDateMonth = formatDate(startDate, monthPattern)
    const endDateMonth = formatDate(endDate, monthPattern)

    const datePattern =
      startDateMonth === endDateMonth ? 'DD' : `DD ${monthPattern}`
    return `${trans(FROM)} ${formatDate(startDate, datePattern)} ${trans(TO)} ${formatDate(endDate)}`
  }

  if (startDate) {
    return `${formatDate(startDate)}`
  }

  return formatDate(endDate) ? `${trans(UNTIL)} ${formatDate(endDate)}` : ''
}
